/**
 * Modal dialog component with optional title, content, and action buttons
 * @exports NikeDialog
 * @author {Cognizant Technology Solutions}
 * @flow
 */
import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import './styles.scss';

interface Props {
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  title?: Object;
  renderContent: Object;
  renderActions?: Object;
  dividers?: boolean;
  open?: any;
  className?: string;
}

/**
 * Renders the nike dialog UI from incoming props.
 * @param {Props} props Component props
 * @returns {ReactComponent} Rendered component
 */
export default function NikeDialog(props: Props) {
  const {
    disableBackdropClick,
    disableEscapeKeyDown,
    title,
    open,
    renderContent,
    renderActions,
    dividers,
    className,
    ...otherProps
  } = props;

  /**
   * Returns title for rendering or state updates.
   * @returns {ReactComponent} Rendered UI
   */
  const getTitle = () => (title ? (
    <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
  ) : null);

  /**
   * Returns actions for rendering or state updates.
   * @returns {ReactComponent} Rendered UI
   */
  const getActions = () => (renderActions ? (
    <DialogActions>
      {renderActions}
    </DialogActions>
  ) : null);

  return (
    <Dialog
      className={`${className || ''} nikeDialogRoot`}
      onClick={(e) => e.stopPropagation()}
      classes={{
        root: 'dialog-root',
        scrollPaper: 'dialog-scrollPaper',
        paper: 'paperStyle'
      }}
      disableBackdropClick={disableBackdropClick}
      disableEscapeKeyDown={disableEscapeKeyDown}
      maxWidth="lg"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...otherProps}
    >
      {getTitle()}
      <DialogContent dividers={dividers}>
        {renderContent}
      </DialogContent>
      {getActions()}
    </Dialog>
  );
}
